import styles from 'css/Switch.module.css'
import {useRef} from 'react'

/**
 * 상태값 없는 완전함수 스위치 LBJ
 */
const Switch2 = ({on=false, onToggle}) => {

    const input = useRef()

    const onClick = () => {
        if (onToggle) onToggle()
    }

    return (
        <div className={on ? styles.default : styles.off} onClick={onClick}>
            {on ? "ON" : "OFF"}
            <input ref={input} type="hidden" defaultValue={on}/>
        </div>
    )
}

export default Switch2